import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FileDown } from "lucide-react";

const SCALINGS = [
  { v: "no_scaling", l: "No Scaling" },
  { v: "fit_one_page", l: "Fit Sheet On One Page" },
  { v: "fit_columns", l: "Fit All Columns On One Page" },
  { v: "fit_rows", l: "Fit All Rows On One Page" },
];

export default function ExportDialog({ open, onOpenChange, onExport }) {
  const [paper, setPaper] = React.useState("A4");
  const [orientation, setOrientation] = React.useState("landscape");
  const [margin, setMargin] = React.useState(10);
  const [scaling, setScaling] = React.useState("fit_one_page");
  const [busy, setBusy] = React.useState(false);

  const handle = async () => {
    setBusy(true);
    try {
      await onExport({ paper, orientation, margin, scaling });
      onOpenChange(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="export-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileDown className="w-5 h-5" /> Export PDF</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-xs mb-1.5 block">Ukuran Kertas</Label>
            <Select value={paper} onValueChange={setPaper}>
              <SelectTrigger data-testid="export-paper"><SelectValue /></SelectTrigger>
              <SelectContent>
                {["A4", "A3", "Letter", "Legal"].map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs mb-1.5 block">Orientasi</Label>
            <Select value={orientation} onValueChange={setOrientation}>
              <SelectTrigger data-testid="export-orientation"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="portrait">Portrait</SelectItem>
                <SelectItem value="landscape">Landscape</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs mb-1.5 block">Margin (mm)</Label>
            <Input type="number" value={margin} onChange={(e) => setMargin(e.target.value)} data-testid="export-margin" />
          </div>
          <div>
            <Label className="text-xs mb-1.5 block">Scaling</Label>
            <Select value={scaling} onValueChange={setScaling}>
              <SelectTrigger data-testid="export-scaling"><SelectValue /></SelectTrigger>
              <SelectContent>
                {SCALINGS.map((s) => <SelectItem key={s.v} value={s.v}>{s.l}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button onClick={handle} disabled={busy} data-testid="export-confirm" className="bg-blue-600 hover:bg-blue-700">
            {busy ? "Mengekspor..." : "Export PDF"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
